import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { QuotesParams } from "@/api/types"

export function quotesOptions(params: QuotesParams = {}) {
	return queryOptions({
		queryKey: ["trading", "quotes", params],
		queryFn: () => GET("/api/v1/trading/quotes", { params: { query: params } }),
		placeholderData: keepPreviousData,
	})
}

export function useQuotes(params: QuotesParams = {}) {
	return useQuery(quotesOptions(params))
}

export function useQuoteCounterparties() {
	return useQuery({
		queryKey: ["trading", "quotes", "counterparties"],
		queryFn: () => GET("/api/v1/trading/quotes/counterparties"),
	})
}
